import { render, staticRenderFns } from "./reports-single-select.vue?vue&type=template&id=85c45976&scoped=true"
import script from "./reports-single-select.vue?vue&type=script&lang=js"
export * from "./reports-single-select.vue?vue&type=script&lang=js"
import style0 from "./reports-single-select.vue?vue&type=style&index=0&id=85c45976&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85c45976",
  null
  
)

export default component.exports